import { render, staticRenderFns } from "./slideshow.vue?vue&type=template&id=5d0dcfae&scoped=true"
import script from "./slideshow.vue?vue&type=script&lang=js"
export * from "./slideshow.vue?vue&type=script&lang=js"
import style0 from "./slideshow.vue?vue&type=style&index=0&id=5d0dcfae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0dcfae",
  null
  
)

export default component.exports